import { createErrorWrapper } from '../utils';

export const LOAD_ERROR = 'CHAT.LOAD_ERROR';

export const loadErr = createErrorWrapper(LOAD_ERROR, 'Failed to chats');
